// ScoreboardArea.js
import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Avatar,
  Divider,
  useTheme,
} from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

function ScoreboardArea({ players }) {
  const theme = useTheme();
  const sortedPlayers = [...players].sort((a, b) => b.score - a.score);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        bgcolor: theme.palette.background.paper,
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          p: 1.5,
          borderBottom: `1px solid ${theme.palette.divider}`,
          bgcolor: theme.palette.background.default,
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, color: theme.palette.text.primary }}
        >
          Scoreboard
        </Typography>
      </Box>

      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <List dense sx={{ p: 0 }}>
          {sortedPlayers.map((player, index) => (
            <React.Fragment key={player.id}>
              <ListItem
                sx={{
                  px: 2,
                  py: 1,
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                  },
                }}
                secondaryAction={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: theme.palette.text.primary,
                      }}
                    >
                      {player.score}
                    </Typography>
                    {index === 0 && player?.score !== 0 && (
                      <EmojiEventsIcon
                        fontSize="small"
                        sx={{ color: theme.palette.warning.main }}
                      />
                    )}
                  </Box>
                }
              >
                <Avatar
                  sx={{
                    width: 32,
                    height: 32,
                    mr: 2,
                    fontSize: "0.875rem",
                    bgcolor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                  }}
                >
                  {player.username.charAt(0).toUpperCase()}
                </Avatar>
                <ListItemText
                  primary={
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 600,
                        color: theme.palette.text.primary,
                      }}
                    >
                      {player.username}
                      {` ${player.isHost ? "(Host)" : ""}`}
                    </Typography>
                  }
                />
              </ListItem>
              <Divider sx={{ bgcolor: theme.palette.divider }} />
            </React.Fragment>
          ))}
        </List>
      </Box>
    </Box>
  );
}

export default ScoreboardArea;
